var map = {
	"./add-existing-registry-banner.gif": 1497,
	"./addexistingregistry_379x180_v2.jpg": 785,
	"./addexistingregistry_548x260.jpg": 1498,
	"./computer.png": 527,
	"./computer@2x.png": 1499,
	"./event.png": 295,
	"./event@2x.png": 1500,
	"./faq.png": 1501,
	"./faq@2x.png": 1502,
	"./home.png": 1503,
	"./home@2x.png": 1504,
	"./photo.png": 1505,
	"./photo@2x.png": 1506,
	"./poi.png": 1507,
	"./poi@2x.png": 1508,
	"./registry-video.jpg": 1509,
	"./registry-video@2x.jpg": 1510,
	"./registry.png": 1511,
	"./registry@2x.png": 1512,
	"./registryconversion_zolaintegration.jpg": 1513,
	"./registryconversion_zolaintegration@2x.jpg": 1514,
	"./rsvp.png": 1515,
	"./rsvp@2x.png": 1516,
	"./travel.png": 1517,
	"./travel@2x.png": 1518,
	"./wedding_party.png": 1519,
	"./wedding_party@2x.png": 1520
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1496;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1496
// module chunks = 43